<template>
    <n-space justify="end" align="center" style="height: 100%" :size="[30, 0]">
        <!-- User Center -->
        <n-dropdown
            :options="userDropdownOptions"
            size="medium"
            trigger="click"
            @select="onUserCenterSelect"
        >
            <n-button circle>
                <n-button circle>
                    <n-icon>
                        <person />
                    </n-icon>
                </n-button>
            </n-button>
        </n-dropdown>
    </n-space>
</template>

<script>
import { h } from "vue";

import { Apps, CodeSlash, Person } from "@vicons/ionicons5";
import {
    NAvatar,
    NText,
    NGrid,
    NGridItem,
    NButton,
    NSpace,
    NIcon,
} from "naive-ui"; // Render Vue components programmatically

import router from "../../router/index.js";
import { logout } from "../../api/user.js";

function renderCustomHeader() {
    return h(NGrid, { cols: 2, xGap: 10 }, () => {
        return [
            h(NGridItem, null, () => {
                return [
                    h(NSpace, { vertical: true }, [
                        h(
                            NButton,
                            {
                                circle: true,
                                size: "large",
                                style: "margin: 6px",
                                onClick: () => {
                                    router.push("/dashboard");
                                },
                            },
                            {
                                icon: () => h(CodeSlash),
                            },
                        ),
                    ]),
                ];
            }),
            h(NGridItem, null, () => {
                return [
                    h(
                        NButton,
                        {
                            circle: true,
                            size: "large",
                            style: "margin: 6px",
                        },
                        () => {
                            return "D";
                        },
                    ),
                ];
            }),
        ];
    });
}

function renderUserDropdown() {
    const username = localStorage.getItem("username");
    const role = localStorage.getItem("role");
    const name = localStorage.getItem("name");
    const course = localStorage.getItem("course");

    return h(
        "div",
        {
            style: "display: flex; align-items: center; padding: 8px 12px;",
        },
        [
            h(
                NIcon,
                { size: "large", style: { "margin-right": "10px" } },
                { default: () => h(Person) },
            ),
            h("div", null, [
                h("div", null, [
                    h(NText, { depth: 2 }, { default: () => name }),
                ]),
                h("div", { style: "font-size: 12px;" }, [
                    h(NText, { depth: 3 }, { default: () => role }),
                ]),
                h("div", { style: "font-size: 12px;" }, [
                    h(
                        NText,
                        { depth: 3 },
                        { default: () => (course ? course : "") },
                    ),
                ]),
            ]),
        ],
    );
}

export default {
    name: "userCenter",
    data() {
        return {
            appCenterOptions: [
                // User center
                {
                    key: "appCenter",
                    type: "render",
                    render: renderCustomHeader,
                },
            ],
            userDropdownOptions: [
                // User center
                {
                    label: "Account",
                    key: "profile",
                    type: "render",
                    render: renderUserDropdown,
                },
                {
                    label: "Logout",
                    key: "logout",
                },
            ],
        };
    },
    methods: {
        onUserCenterSelect(key) {
            switch (key) {
                case "logout": {
                    localStorage.removeItem("token");
                    logout().then((res) => {
                        this.$router.push("/");
                    });
                    break;
                }
            }
        },
    },
    components: {
        Apps,
        Person,
    },
};
</script>

<style scoped></style>
